import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { Question } from 'src/app/models/question';
import { AuthService } from 'src/app/services/auth.service';
import { ToolsService } from 'src/app/services/tools.service';
import { ConfirmationModalComponent } from '../confirmation-modal/confirmation-modal.component';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss'],
})
export class SignupComponent implements OnInit {
  @Input() showBack: boolean = false;
  @Input() loginData?: { document: string; document_type: string };

  @Output() onContinue: EventEmitter<any> = new EventEmitter<any>();
  @Output() onBack: EventEmitter<any> = new EventEmitter<any>();

  signupQuestions: Array<Question> = [];
  loading: boolean = false;
  allowEmail: boolean = true;
  allowSMS: boolean = true;

  constructor(
    private recaptchaV3Service: ReCaptchaV3Service,
    private authService: AuthService,
    private modalController: ModalController,
    private toolService: ToolsService
  ) {
    this.loadQuestions();
  }

  ngOnInit() {}

  loadQuestions() {
    // Get min and max dates for the birthdate
    let now = new Date();
    // Min date is 100 years ago
    let minDate: Date = new Date();
    minDate.setFullYear(now.getFullYear() - 100);
    // Max date is 18 years ago
    let maxDate: Date = new Date();
    maxDate.setFullYear(now.getFullYear() - 18);
    // Start signup questions
    this.signupQuestions = [
      {
        id: 'cellphone',
        label: 'Celular *',
        type: 'text',
        formControl: new FormControl('', [
          Validators.required,
          Validators.pattern(/^3\d{9}$/),
        ]),
        errorText: {
          pattern: 'El número de celular debe iniciar con 3 y tener 10 dígitos',
        },
      },
      {
        id: 'email',
        label: 'Correo electrónico *',
        type: 'text',
        formControl: new FormControl('', [
          Validators.required,
          Validators.email,
          Validators.pattern(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/),
        ]),
        errorText: { pattern: 'Debes ingresar un correo electrónico válido' },
      },
      {
        id: 'name',
        label: 'Nombre *',
        type: 'text',
        formControl: new FormControl('', [Validators.required]),
      },
      {
        id: 'lastname',
        label: 'Apellidos *',
        type: 'text',
        formControl: new FormControl('', [Validators.required]),
      },
      {
        id: 'birthdate',
        label: 'Fecha de nacimiento *',
        type: 'date',
        formControl: new FormControl('', [Validators.required]),
        minDate: minDate.toISOString(),
        maxDate: maxDate.toISOString(),
        defaultValue: maxDate.toISOString(),
      },
    ];
  }

  goBack() {
    this.onBack.emit();
  }

  async continue() {
    // Validate form
    let valid: boolean = true;
    this.signupQuestions.forEach((question) => {
      if (!question.formControl.valid) {
        question.formControl.markAsTouched();
        valid = false;
      }
    });
    if (!valid) return;
    if (!this.loginData) {
      console.error('Login data not found');
      return;
    }

    this.loading = true;

    // Validate captcha
    let captchaToken = await this.validateCaptcha();

    // let document_type = this.toolService.getValueFromQuestion('document-type', this.loginQuestions);
    // let document = this.toolService.getValueFromQuestion('document', this.loginQuestions);

    let documentType = this.loginData.document_type;
    let document = this.loginData.document;
    let cellphone = this.toolService.getValueFromQuestion(
      'cellphone',
      this.signupQuestions
    );
    let name = this.toolService.getValueFromQuestion(
      'name',
      this.signupQuestions
    );
    let lastname = this.toolService.getValueFromQuestion(
      'lastname',
      this.signupQuestions
    );
    let email = this.toolService.getValueFromQuestion(
      'email',
      this.signupQuestions
    );
    let bornDate = this.toolService.getValueFromQuestion(
      'birthdate',
      this.signupQuestions
    );

    // this.authService.signup(
    //   documentType, document, cellphone, name, lastname, email, bornDate, captchaToken,this.allowSMS, this.allowEmail
    // ).subscribe({
    //   next: (data) => {
    //     console.debug('Signup success', data);
    //     this.authService.setToken(data.token);
    //     this.loading = false;
    //     this.onContinue.emit({
    //       next: 'upload-bills', data: { document_type: documentType, document, email, userId: data.token }
    //     });
    //   }, error: (err) => {
    //     this.loading = false;
    //     console.error('Signup error', err);
    //     if (err.status == 409) this.toolService.presentErrorToast('El documento ingresado ya se encuentra registrado en el sistema');
    //     else this.toolService.presentErrorToast('Ocurrió un error inesperado, intenta de nuevo más tarde');
    //   }
    // });
  }

  validateCaptcha(): Promise<string> {
    return new Promise((resolve, reject) => {
      this.recaptchaV3Service.execute('signup').subscribe((token: string) => {
        // console.debug(`Captcha token [${token}] generated`);
        resolve(token);
      });
    });
  }

  async openModal(message: string, isSMS: boolean = false) {
    const modal = await this.modalController.create({
      component: ConfirmationModalComponent,
      cssClass: 'custom-alert-modal',
      componentProps: { message, isSMS },
    });

    modal.onDidDismiss().then((data: any) => {
      if (data?.data && isSMS) {
        this.allowSMS = data;
      } else if (data?.data && !isSMS) {
        this.allowEmail = data;
      }
    });
    return await modal.present();
  }

  onSMSChange() {
    if (!this.allowSMS) {
      this.openModal(
        '¿Estás seguro de que no deseas recibir notificaciones por SMS?',
        true
      );
    }
  }

  onEmailChange() {
    if (!this.allowEmail) {
      this.openModal(
        '¿Estás seguro de que no deseas recibir notificaciones por correo electrónico?'
      );
    }
  }
}
